import {
  RevenueData,
  RevenueTable,
  yearSuffix,
} from "../../../components/RevenueTable/RevenueTable";
import React, { useEffect, useState } from "react";
import { MemberModal } from "@milestone/component-library";
import { useParams } from "react-router-dom";
import { CultureIndexTable } from "../../../components/CultureIndexTable";
import {
  Chart,
  ChartsContainer,
  ChartTitle,
  Container,
  Content,
  InnerContent,
  Tab,
  TabContainer,
  TileContainer,
} from "./styles";
import { InformationTile } from "../../../components/InformationTile";
import { StrengthFinder } from "../../../components/StrengthFinder";
import { CheckinProgress } from "../../../components/CheckinProgress";
import { useAppSelector } from "../../../store/hooks";
import { useMemberDetails } from "../../../services/hooks/MemberDetails";
import { makeName } from "../../../services/hooks/MembersList";
import {
  MonthNamesShort,
  RevenueEntry,
  StrengthFinderDetails,
} from "../../../services/api/types/Members";
import { Api } from "../../../services/api";

export const EmployeeDetail: React.FC<{}> = () => {
  const { memberId } = useParams<{ memberId: string }>();
  const [open, setOpen] = useState(true);
  const member = useMemberDetails(memberId);
  const [selectedTab, setSelectedTab] = useState<string>("Culture Index");
  const [loaded, setLoaded] = useState(false);
  const token = useAppSelector(state => state.auth.token);
  const [revData, setRevData] = useState<Array<RevenueData>>([]);
  const [strengthsMap, setStrengthsMap] = useState(
    new Map<string, StrengthFinderDetails>()
  );

  function buildRevenueData(revenueEntries: Array<RevenueEntry>) {
    const revMap = new Map<string, RevenueData>();
    for (const entry of revenueEntries) {
      const date = new Date(entry.date);
      const month = MonthNamesShort[date.getMonth()];
      const label = date.getFullYear() + yearSuffix;
      if (revMap.has(month)) {
        const val = revMap.get(month) as RevenueData;
        val[label] = entry.amount;
      } else {
        revMap.set(month, {
          monthName: month,
          [label]: entry.amount,
        });
      }
    }
    const revData = new Array<RevenueData>();
    for (const month of MonthNamesShort) {
      const entry = revMap.get(month);
      if (entry) {
        revData.push(entry);
      }
    }
    setRevData(revData);
  }

  function buildStrengthFinderMap() {
    Api.members.getStrengthFinderAttributes().then(res => {
      const strengthsMap = new Map<string, StrengthFinderDetails>();
      for (const strength of res.data) {
        strengthsMap.set(strength.id, strength);
      }
      setStrengthsMap(strengthsMap);
    });
  }

  useEffect(() => {
    buildStrengthFinderMap();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (member) {
      setLoaded(true);
      if (member.revenueEntries) {
        buildRevenueData(member.revenueEntries);
      }
    }
  }, [member]);

  const handleClose = (open = false) => {
    setOpen(open);
  };

  const handleTabSelect = (e: any) => {
    if (e.currentTarget.value === selectedTab) return;
    setSelectedTab(e.currentTarget.value);
  };

  return (
    <Container>
      <MemberModal
        memberInfo={member}
        open={open}
        handleClose={handleClose}
        uncloseable={true}
        token={token}
      />
      <Content>
        <InnerContent>
          <TileContainer>
            <InformationTile
              title={"Win Rate MTD"}
              height={"167px"}
              width={"262px"}
              value={"266%"}
              isLoading={false}
            />
            {/*
            <InformationTile
              title={"Advances Balance"}
              height={"167px"}
              width={"262px"}
              value={"$250"}
              isLoading={false}
            />
            */}
            <InformationTile
              title={"Leader Review"}
              height={"167px"}
              width={"262px"}
              value={"130"}
              isLoading={false}
            />
            {/*
            <InformationTile
              title={"Weekly Comp Average"}
              height={"167px"}
              width={"262px"}
              value={"$1,234"}
              isLoading={false}
            />
            */}
          </TileContainer>

          <ChartsContainer>
            <Chart>
              <ChartTitle>Revenue Targets</ChartTitle>
              <RevenueTable data={revData} />
            </Chart>

            <Chart>
              <TabContainer>
                <Tab
                  value="Culture Index"
                  onClick={(e: any) => handleTabSelect(e)}
                  isSelected={selectedTab === "Culture Index" ? true : false}
                >
                  Culture Index
                </Tab>
                <Tab
                  value="StrengthsFinder"
                  onClick={(e: any) => handleTabSelect(e)}
                  isSelected={selectedTab === "StrengthsFinder" ? true : false}
                >
                  StrengthsFinder
                </Tab>
              </TabContainer>
              {loaded && member && (
                <div>
                  {selectedTab === "Culture Index" ? (
                    <CultureIndexTable
                      data={member.cultureIndexEntries || []}
                      name={makeName(member.member)}
                    />
                  ) : (
                    <>
                      {strengthsMap.size &&
                      member.employmentInfo?.strengthFinderAttributes ? (
                        <>
                          {member.employmentInfo.strengthFinderAttributes.map(
                            attribute => {
                              const strength = strengthsMap.get(
                                attribute.attributeId
                              );
                              if (strength)
                                return (
                                  <StrengthFinder
                                    key={attribute.attributeId}
                                    color={`#${strength.themeColor}`}
                                    title={strength.themeName}
                                    description={strength.themeDesc}
                                  />
                                );
                            }
                          )}
                        </>
                      ) : null}
                    </>
                  )}
                </div>
              )}
            </Chart>
          </ChartsContainer>

          <ChartsContainer>
            <Chart>
              {member ? (
                <CheckinProgress
                  hireDate={member.member.hireDate || new Date()}
                  checkIns={member.checkins || []}
                />
              ) : null}
            </Chart>
          </ChartsContainer>
        </InnerContent>
      </Content>
    </Container>
  );
};
